export default "__VITE_ASSET__60f80e3b__"